/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SkipForwardIcon = /*#__PURE__*/ createSvgIcon(
  'SkipForwardIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M13.5 14.25v-8.5c0-.213.072-.39.214-.534A.72.72 0 0114.246 5c.21 0 .39.072.535.216A.72.72 0 0115 5.75v8.5c0 .213-.072.39-.214.534a.72.72 0 01-.532.216.734.734 0 01-.535-.216.72.72 0 01-.219-.534zM5 13.119V6.882c0-.227.076-.41.228-.549a.763.763 0 01.531-.208c.063 0 .126.01.189.031.062.021.128.052.198.094l4.875 3.125a.747.747 0 01.25.274.747.747 0 01.083.35.754.754 0 01-.083.35.751.751 0 01-.25.276L6.146 13.75a1.01 1.01 0 01-.198.094.594.594 0 01-.189.031.764.764 0 01-.531-.208A.707.707 0 015 13.12zm1.5-1.369L9.23 10 6.5 8.25v3.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default SkipForwardIcon;
